import {LovValueSummaryConverter} from './LovValueSummary.converter';
import {HttpModelConverter} from '../../../../../core/converter/httpModel.converter';
import {LovValue} from '../model/LovValue.model';
import {AccountSummaryConverter} from '../../../../../account/common/api.converter/AccountSummary.converter';
import {LovListSummaryConverter} from '../../../lov-list/api/model/converter/lovListSummary.converter';
import {Injectable} from '@angular/core';

@Injectable({providedIn: 'root'})
export class LovValueConverter extends HttpModelConverter<LovValue>{

    protected createInstance(): LovValue {
        return new LovValue();
    }

    protected enrichObject(result: LovValue, src: LovValue) {
        result.summary = new LovValueSummaryConverter().convert(src.summary);
        result.account = new AccountSummaryConverter().convert(src.account);
        result.parent = new LovValueSummaryConverter().convert(src.parent);
        result.lovList = new LovListSummaryConverter().convert(src.lovList);
    }
}
